import { configurePdf } from '@eudia/file-rendering-engine/viewers/pdf/configure';
import { initPostHog } from '@eudia/telemetry/product-analytics/init';

configurePdf({
  workerSrc: '/pdfjs/pdf.worker.min.mjs',
  cMapUrl: '/pdfjs/cmaps/',
  standardFontDataUrl: '/pdfjs/standard_fonts/',
  wasmUrl: '/pdfjs/wasm/',
});

initPostHog(process.env.NEXT_PUBLIC_POSTHOG_KEY ?? '');
